import React from 'react';
import {
  changeTimeFormat,
  getCellValue
} from '@nile/reports/src/modules/EfficiencyReport/util';
import { FormattedMessage } from 'react-intl';
import { TextStyle } from '@superops/ui-design-system';

function TimeCell({ cell }) {
  const { value, row, column } = cell;
  const timeValue = value || getCellValue(row?.original, column?.accessorKey);
  const { days, hours, minutes } = changeTimeFormat(timeValue);
  const hasTimeValue = days || hours || minutes;
  if (!value || !hasTimeValue) {
    return (
      <div className="mlr5">
        <TextStyle variation="subdued">
          <FormattedMessage id="app.noData.message" />
        </TextStyle>
      </div>
    );
  }

  return (
    <div className="mlr5">{`${(days && `${days}d`) || ''} ${(hours &&
      `${hours}h`) ||
      ''} ${(minutes && `${minutes}m`) || ''}`}</div>
  );
}

export default TimeCell;
